import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Image from "../Image/Excel-Image.png"; // your image

const GREY = "FFF2F2F2";
const GREEN = "FF93C572";
const YELLOW = "FFFFFF2E";
const RED = "FFFF2E2E";

// ── small colour-rule helpers, one per question "type" used on the form ──────
const devColor = (val) =>
  val === "Available" ? GREEN : val === "To be developed" ? YELLOW : val === "Regret" ? RED : undefined;

const drawColor = (val) =>
  val === "Available" || val === "Not Required" ? GREEN : val === "Essential to proceed" ? RED : undefined;

const achievColor = (val) =>
  val === "Achievable" ? GREEN : val === "Need detailed study" ? YELLOW : val === "Not achievable" ? RED : undefined;

const packColor = (val) =>
  val === "MI Standard" ? GREEN : val === "Customer Specific" ? YELLOW : val === "Not achievable" ? RED : undefined;

const toleranceColor = (val) =>
  val === "Greater than 0.5" ? GREEN : val === "0.1 - 0.5" ? YELLOW : val === "Less than 0.1" ? RED : undefined;

const statutoryColor = (val) =>
  val === "No" || val === "Yes, & Complied" ? GREEN
    : val === "Yes, Will be complied" ? YELLOW
    : val === "Cannot comply" ? RED
    : undefined;

const riskColor = (val) => (val === "Low" ? GREEN : val === "Med" ? YELLOW : val === "High" ? RED : undefined);

const spareColor = (val) => (val === "Yes" ? GREEN : val === "No" ? YELLOW : undefined);

const unstatedColor = (val) => (val === "No" ? GREEN : val === "Yes" ? YELLOW : undefined);

const boolColor = (flag) => (flag ? YELLOW : GREEN); // hole punching / assembly / outsource: doing extra work = yellow

export const downloadExcel = async (
  enquirieNo, customerName, customerRefNo, kAMName, rfqDate, profileName, sampleImage, profileNo,
  twoD, threeD, machine, rollTools, bendingTools, fixture,
  click1, click4, shortRadiusBendingRadius, click5, longRadiusBendingRadius,
  click2, laserCuttingLength, click3, powderCoatingLength,
  holePunching, holePunchingDetails, assemblyProcess, assemblyProcessDetails,
  click6, outsourceActivity,
  material, materialIndianEquiv, tolerance, customerSpecReq, packingSpc, sample,
  volumeMonthly, volumeMonthlyInTon, volumeYearly, volumeYearlyInTon,
  spare, reason, statuttery, unstared, unstaredval, risk, riskReason,
  result, unit1, unit2, type, stripWidth, thickness, boxPerimeter, length,
  enquirieDate, reviewDate, modificationSummary = []
) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Feasibility-L1");
  const weight = (stripWidth * thickness * 7850 * 0.000001).toFixed(3);

  // ── generic helpers ─────────────────────────────────────────────────────────
  const setCell = (row, col, value, fill) => {
    const cell = worksheet.getCell(row, col);
    cell.value = value;
    if (fill) cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: fill } };
    return cell;
  };
  const merge = (r1, c1, r2, c2) => worksheet.mergeCells(r1, c1, r2, c2);
  const label = (row, col, value) => setCell(row, col, value, GREY);
  const fillRange = (r1, c1, r2, c2, fill) => {
    for (let r = r1; r <= r2; r++) {
      for (let c = c1; c <= c2; c++) {
        worksheet.getCell(r, c).fill = { type: "pattern", pattern: "solid", fgColor: { argb: fill } };
      }
    }
  };

  // ── Header (rows 1-9) ─────────────────────────────────────────────────────
  merge(1, 1, 3, 3); // logo area
  setCell(1, 4, "MOTHER INDIA FORMING PVT. LTD."); merge(1, 4, 2, 11);
  label(1, 12, "Doc. No."); setCell(1, 13, "");
  label(2, 12, "Rev. No."); setCell(2, 13, "");
  setCell(3, 4, "Feasibility - L1"); merge(3, 4, 3, 11);
  label(3, 12, "Rev. Date"); setCell(3, 13, "");

  label(4, 1, "Customer Name:"); merge(4, 1, 4, 3);
  setCell(4, 4, customerName); merge(4, 4, 4, 9);
  label(4, 10, "Customer Ref. No.:"); merge(4, 10, 4, 11);
  setCell(4, 12, customerRefNo); merge(4, 12, 4, 13);

  label(5, 1, "Enquiry No.:"); merge(5, 1, 5, 3);
  setCell(5, 4, enquirieNo); merge(5, 4, 5, 5);
  label(5, 6, "Enquiry Date:"); merge(5, 6, 5, 7);
  setCell(5, 8, enquirieDate);
  label(5, 10, "Review Date"); merge(5, 10, 5, 11);
  setCell(5, 12, reviewDate); merge(5, 12, 5, 13);

  label(6, 1, "Part Name:"); merge(6, 1, 6, 3);
  setCell(6, 4, profileName); merge(6, 4, 6, 9);
  label(6, 10, "Part No.:"); merge(6, 10, 6, 11);
  setCell(6, 12, profileNo); merge(6, 12, 6, 13);

  label(7, 1, "RFQ Date:"); merge(7, 1, 7, 3);
  setCell(7, 4, rfqDate); merge(7, 4, 7, 13);

  setCell(8, 1, "Feasibility consideration: Following questions were considered (all questions not mandatory). The drawings and/or specifications provided have been used as a basis for analyzing the ability to meet all specified requirements.");
  merge(8, 1, 9, 13);

  // ── Table header (row 9) ─────────────────────────────────────────────────
  label(10, 1, "Sl. No.");
  label(10, 2, "Consideration"); merge(10, 2, 10, 5);
  label(10, 6, "Specification"); merge(10, 6, 10, 8);
  label(10, 9, "Value");
  label(10, 10, "Remarks / Action"); merge(10, 10, 10, 11);
  label(10, 12, "Resp.");
  label(10, 13, "Target");

  // ── 1. Drawing issued by customer (rows 10-11) ───────────────────────────
  setCell(11, 1, "1"); merge(11, 1, 12, 1);
  setCell(11, 2, "Drawing issued by customer,"); merge(11, 2, 12, 5);
  label(11, 6, "2D"); merge(11, 6, 11, 8);
  setCell(11, 9, twoD, drawColor(twoD));
  label(12, 6, "3D"); merge(12, 6, 12, 8);
  setCell(12, 9, threeD, drawColor(threeD));

  // ── 2. Availability of equipments (rows 12-15) ───────────────────────────
  // FIX: "Tools" split into "Roll Tools" (row 13) and "Bending Tools" (row 14),
  // each independently scored Available / To be developed / Regret, same as Machine/Fixtures.
  setCell(13, 1, "2"); merge(13, 1, 16, 1);
  setCell(13, 2, "Availability of equipments,"); merge(13, 2, 16, 5);
  label(13, 6, "Machine"); merge(13, 6, 13, 8);
  setCell(13, 9, machine, devColor(machine));
  label(14, 6, "Roll Tools"); merge(14, 6, 14, 8);
  setCell(14, 9, rollTools, devColor(rollTools));
  label(15, 6, "Bending Tools"); merge(15, 6, 15, 8);
  setCell(15, 9, bendingTools, devColor(bendingTools));
  label(16, 6, "Fixtures / Measuring Eq"); merge(16, 6, 16, 8);
  setCell(16, 9, fixture, devColor(fixture));

  // ── 3. In-house process involved (rows 16-32) ────────────────────────────
  setCell(17, 1, "3"); merge(17, 1, 33, 1);
  setCell(17, 2, "¡) In-House process involved,"); merge(17, 2, 17, 8);

  setCell(18, 2, "Roll forming process"); merge(18, 2, 23, 5);
  label(18, 6, "Open/Non Welding section"); merge(18, 6, 20, 7);
  label(18, 8, "Strip width (mm)");
  setCell(18, 9, type === "Open" ? stripWidth : "",
    type === "Open" ? (stripWidth > 10 && stripWidth <= 350 ? GREEN : RED) : undefined);
  label(19, 8, "Thickness (mm)");
  setCell(19, 9, type === "Open" ? thickness : "",
    type === "Open" ? (thickness > 0.4 && thickness <= 5 ? GREEN : RED) : undefined);
  label(20, 8, "Weight (kg/m)");
  setCell(20, 9, type === "Open" ? weight : "");

  label(21, 6, "Closed/Welding section"); merge(21, 6, 23, 7);
  label(21, 8, "Strip width (mm)");
  setCell(21, 9, type === "Close" ? stripWidth : "",
    type === "Close" ? (stripWidth > 10 && stripWidth <= 500 ? GREEN : RED) : undefined);
  label(22, 8, "Thickness (mm)");
  setCell(22, 9, type === "Close" ? thickness : "",
    type === "Close" ? (thickness > 0.8 && thickness <= 10 ? GREEN : RED) : undefined);
  label(23, 8, "Weight (kg/m)");
  setCell(23, 9, type === "Close" ? weight : "");

  setCell(24, 2, "Post Forming process"); merge(24, 2, 32, 5);
  label(24, 6, "Bending"); merge(24, 6, 27, 6);
  label(24, 7, "Short Radius"); merge(24, 7, 25, 7);
  label(24, 8, "Radius(mm)");
  setCell(24, 9, click4 ? shortRadiusBendingRadius : "", click1 && click4 ? GREEN : undefined);
  label(25, 8, "Thickness (mm)");
  setCell(25, 9, click4 ? thickness : "", click1 && click4 ? GREEN : undefined);
  label(26, 7, "Long Radius"); merge(26, 7, 27, 7);
  label(26, 8, "Radius(mm)");
  setCell(26, 9, click5 ? longRadiusBendingRadius : "", click1 && click5 ? GREEN : undefined);
  label(27, 8, "Thickness (mm)");
  setCell(27, 9, click5 ? thickness : "", click1 && click5 ? GREEN : undefined);

  label(28, 6, "Laser cutting"); merge(28, 6, 29, 7);
  label(28, 8, "Length(mm)");
  setCell(28, 9, click2 ? laserCuttingLength : "",
    click2 ? (laserCuttingLength > 10 && laserCuttingLength <= 3000 ? GREEN : RED) : undefined);
  label(29, 8, "Thickness (mm)");
  setCell(29, 9, click2 ? thickness : "",
    click2 ? (thickness > 0.8 && thickness <= 10 ? GREEN : RED) : undefined);

  label(30, 6, "Powder coating"); merge(30, 6, 30, 7);
  label(30, 8, "Length(mm)");
  setCell(30, 9, click3 ? powderCoatingLength : "",
    click3 ? (powderCoatingLength > 200 && powderCoatingLength <= 3000 ? GREEN : RED) : undefined);

  label(31, 6, "Hole Punching"); merge(31, 6, 31, 8);
  setCell(31, 9, holePunching ? "Yes" : "No", boolColor(holePunching));

  label(32, 6, "Assembly process"); merge(32, 6, 32, 8);
  setCell(32, 9, assemblyProcess ? "Yes" : "No", boolColor(assemblyProcess));

  setCell(33, 2, "¡¡) Any outsource activity required ,"); merge(33, 2, 33, 7);
  setCell(33, 8, outsourceActivity, boolColor(click6));

  // ── 4. Engineering specification (rows 33-34) ────────────────────────────
  setCell(34, 1, "4"); merge(34, 1, 35, 1);
  setCell(34, 2, "Can engineering specifications specified by customer be met?"); merge(34, 2, 35, 5);
  label(34, 6, "Material"); merge(34, 6, 34, 8);
  setCell(34, 9, material);
  setCell(34, 10, materialIndianEquiv); merge(34, 10, 34, 11);
  label(35, 6, "Tolerance"); merge(35, 6, 35, 8);
  setCell(35, 9, tolerance, toleranceColor(tolerance));

  // ── 5. Additional documents (rows 35-36) ─────────────────────────────────
  setCell(36, 1, "5"); merge(36, 1, 37, 1);
  setCell(36, 2, "Any additional documents required?"); merge(36, 2, 37, 5);
  label(36, 6, "on Customer Spc. Requirement"); merge(36, 6, 36, 8);
  setCell(36, 9, customerSpecReq, achievColor(customerSpecReq));
  label(37, 6, "on Packing Spc."); merge(37, 6, 37, 8);
  setCell(37, 9, packingSpc, packColor(packingSpc));

  // ── 6. Sample (row 37) ────────────────────────────────────────────────────
  setCell(38, 1, "6");
  setCell(38, 2, "Any sample required from the customer?"); merge(38, 2, 38, 8);
  setCell(38, 9, sample, drawColor(sample));

  // ── 7. Projected volume (rows 38-39) ─────────────────────────────────────
  setCell(39, 1, "7"); merge(39, 1, 40, 1);
  setCell(39, 2, "Projected Volume"); merge(39, 2, 40, 5);
  label(39, 6, "Monthly (Tons)"); merge(39, 6, 39, 8);
  setCell(39, 9, volumeMonthlyInTon);
  label(40, 6, "Yearly (Tons)"); merge(40, 6, 40, 8);
  setCell(40, 9, volumeYearlyInTon);

  // ── 8. Spare capacity (row 40) ────────────────────────────────────────────
  setCell(41, 1, "8");
  setCell(41, 2, "Considering Project Volume, is spare capacity available?"); merge(41, 2, 41, 8);
  setCell(41, 9, spare, spareColor(spare));

  // ── 9. Statutory & regulatory (row 41) ────────────────────────────────────
  setCell(42, 1, "9");
  setCell(42, 2, "Statutory and Regulatory requirements?"); merge(42, 2, 42, 8);
  setCell(42, 9, statuttery, statutoryColor(statuttery));

  // ── 10. Unstated requirements (row 42) ────────────────────────────────────
  setCell(43, 1, "10");
  setCell(43, 2, "Any Unstated requirements?"); merge(43, 2, 43, 8);
  setCell(43, 9, unstared, unstatedColor(unstared));

  // ── 11. Business risk (row 43) ────────────────────────────────────────────
  setCell(44, 1, "11");
  setCell(44, 2, "Any other points considered (Such as business Risk Etc.,)"); merge(44, 2, 44, 8);
  setCell(44, 9, risk, riskColor(risk));

  // ── Conclusion + Modification Summary (rows 44-47) ───────────────────────
  setCell(45, 1, "Conclusion:"); merge(45, 1, 45, 6);
  setCell(45, 7, "Modification Summary"); merge(45, 7, 45, 13);

  const resultText = result === 2 ? "FEASIBLE" : result === 1 ? "FEASIBLE WITH MODIFICATION" : "NOT FEASIBLE";
  const resultColor = result === 2 ? GREEN : result === 1 ? YELLOW : RED;
  setCell(46, 1, resultText); merge(46, 1, 48, 6);
  fillRange(46, 1, 48, 6, resultColor);

  const summaryText = modificationSummary && modificationSummary.length
    ? modificationSummary.map((item, idx) => `${idx + 1}. ${item}`).join("\n")
    : "-";
  const summaryCell = setCell(46, 7, summaryText);
  merge(46, 7, 48, 13);
  summaryCell.alignment = { wrapText: true, vertical: "top", horizontal: "left" };

  // ── Any other concerns (row 48) ──────────────────────────────────────────
  setCell(49, 1, "Any other concerns:"); merge(49, 1, 49, 13);

  // ── Quote reference rows (50-52) ─────────────────────────────────────────
  setCell(51, 1, "If it is feasible send quotation to the customer"); merge(51, 1, 51, 6);
  label(51, 7, "Quote Ref No.:"); merge(51, 7, 51, 8);
  merge(51, 9, 51, 13);

  setCell(52, 1, "If it is feasible with modification discuss with customer"); merge(52, 1, 52, 6);
  label(52, 7, "Quote Ref No.:"); merge(52, 7, 52, 8);
  merge(52, 9, 52, 13);

  setCell(53, 1, "In case not feasible send the regret letter / mail to customer "); merge(53, 1, 53, 6);
  label(53, 7, "Letter / mail Ref:"); merge(53, 7, 53, 8);
  merge(53, 9, 53, 13);

  // ── Notes / legend (rows 55-59) ──────────────────────────────────────────
  setCell(56, 1, "Note:"); merge(56, 1, 56, 13);
  setCell(57, 1, "Feasibility Conclusion understanding"); merge(57, 1, 57, 13);

  setCell(58, 1, "1");
  setCell(58, 2, "FEASIBLE", GREEN); merge(58, 2, 58, 5);
  setCell(58, 6, "The product specification are well within the MI development range."); merge(58, 6, 58, 13);

  setCell(59, 1, "2");
  setCell(59, 2, "FEASIBLE WITH MODIFICATION", YELLOW); merge(59, 2, 59, 5);
  setCell(59, 6, "Specification are in the development range, the product development is feasible with development of tools/fixtures etc."); merge(59, 6, 59, 13);

  setCell(60, 1, "3");
  setCell(60, 2, "NOT FEASIBLE", RED); merge(60, 2, 60, 5);
  setCell(60, 6, "The product specification are not MI development range."); merge(60, 6, 60, 13);

  const LAST_ROW = 62; // includes buffer rows before the sample image

  // ── base styling pass (borders + alignment only — fills were set above) ──
  for (let r = 1; r <= LAST_ROW; r++) {
    for (let c = 1; c <= 13; c++) {
      const cell = worksheet.getCell(r, c);
      cell.alignment = { horizontal: "center", vertical: "middle", wrapText: true };
      cell.border = {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      };
      if (r >= 1 && r <= 10) cell.font = { bold: true };
    }
  }
  // keep the modification-summary text left/top aligned and wrapped after the base pass
  summaryCell.alignment = { wrapText: true, vertical: "top", horizontal: "left" };

  // ── Images ────────────────────────────────────────────────────────────────
  const response = await fetch(Image);
  const imageBlob = await response.blob();
  const arrayBuffer = await imageBlob.arrayBuffer();
  const imageId = workbook.addImage({ buffer: arrayBuffer, extension: "png" });
  worksheet.addImage(imageId, {
    tl: { col: 0, row: 0 },
    br: { col: 3, row: 3 },
    editAs: "oneCell",
  });

  const response1 = await fetch(sampleImage);
  const imageBlob1 = await response1.blob();
  const arrayBuffer1 = await imageBlob1.arrayBuffer();
  const imageId2 = workbook.addImage({ buffer: arrayBuffer1, extension: "png" });
  worksheet.addImage(imageId2, {
    tl: { col: 1, row: LAST_ROW },
    ext: { width: 500, height: 350 },
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), "Feasibility-L1.xlsx");
};
